import { usePost, CPLAT_API_ROUTES } from '@/api';
import { useAppSelector } from '@/redux/store';
import { BlogPosting } from '@/types/discover';
import { useEffect, useState } from 'react';

export const useBlogPreview = () => {
  const { CplatToken } = useAppSelector((s) => s.user);
  const [blogList, setBlogList] = useState<BlogPosting[]>([]);
  const { mutate: getBlogPosting } = usePost(CPLAT_API_ROUTES.getBlogPosting);

  useEffect(() => {
    getBlogPosting(
      { cplatToken: CplatToken },
      {
        onSuccess(res) {
          const list = res.data?.data?.[0]?.BlogPostingList || [];
          setBlogList(list.slice(0, 4)); // 상위 2개만
        },
      },
    );
  }, [CplatToken, getBlogPosting]);

  return { blogList };
};
